import React, { FC } from 'react';
import { Responsive, Typography, getClassNameFactory } from '@dcl/ui';
import { IEmptySearch } from './EmptySearch.type';
import {
  DESKTOP_MIN_WIDTH,
  MOBILE_MAX_WIDTH,
  NOT_FOUND_MSG,
  NOT_FOUND_MSG_DYNAMIC,
  TEST_SEARCH_STRING,
} from './constants';
import './EmptySearch.css';
import AlertIcon from './Icons/AlertIcon';
import AlertIconMobile from './Icons/AlertIconMobile';
import { BoldedText } from './components/BoldedText';

export const EmptySearch: FC<IEmptySearch> = (props) => {
  const getClassName = getClassNameFactory(EmptySearch.displayName);
  let { emptySearchMsg, searchTerm } = props;

  if (!searchTerm && !emptySearchMsg) {
    searchTerm = '';
    emptySearchMsg = NOT_FOUND_MSG;
  } else if (searchTerm && !emptySearchMsg) {
    emptySearchMsg = NOT_FOUND_MSG_DYNAMIC;
  } else if (!searchTerm && emptySearchMsg) {
    searchTerm = TEST_SEARCH_STRING;
  }

  return (
    <div className={getClassName()}>
      <div className={getClassName({ descendantName: 'svg' })}>
        <Responsive minWidth={DESKTOP_MIN_WIDTH}>
          <AlertIcon />
        </Responsive>
        <Responsive minWidth={0} maxWidth={MOBILE_MAX_WIDTH}>
          <AlertIconMobile />
        </Responsive>
      </div>
      <div>
        <Typography className={getClassName({ descendantName: 'noResultMsg' })}>
          {emptySearchMsg && BoldedText(emptySearchMsg, searchTerm)}
        </Typography>
      </div>
    </div>
  );
};

EmptySearch.displayName = 'EmptySearch';
